import { Component, ViewChild, ElementRef } from '@angular/core';
import { NewRegisterFormService } from './new.register.form.service';
import { EmployerFormService } from '../../EmployerComponent/EmployerFormComponent/employer.form.service';
import { EmployerViewService } from '../../EmployerComponent/EmployerViewComponent/employer.view.service';
import { NewProjectViewService } from '../../ProjectComponent/NewProjectViewComponent/new.project.view.service';
import { FormControl, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { NewRegisterViewService } from '../NewRegisterViewComponent/new.register.view.service';
import { Countries } from '../../shared/countries/countries';
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import customerJson from "../../../assets/config/customer.json";
import translateJson from "../../../translate.json";
import { DateAdapter, MatDatepicker } from '@angular/material';
import { AppService } from '../../app.service';
import { Formvalidator } from './new.register.form.formvalidator';
import { PersonFormService } from '../../PersonComponent/PersonFormComponent/person.form.service';
import { ActivatedRoute } from '@angular/router'; 
import { formatDate } from '@angular/common';
import { Globals } from '../../globals';
import { startWith } from 'rxjs/operators/';

import { ValidationModalComponent } from '../../shared/views/ValidationModalComponent/validation.modal.component';
import { SuaStatusType } from '../../shared/enum/SuaStatusType';
import { SearchDropdownComponent } from '../../shared/input/SearchableDropdown/search.dropdown.component'
import { ConfirmModalService } from 'app/shared/views/ConfirmModalComponent/confirm.modal.service';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';

import { DateUpdateFix } from '../../models/date-update-fix';
import { AuthenticationService } from '../../auth';

enum otherTypeEnum {RK, RKATTACHMENT};

@Component({
    selector: 'register-comp',
    providers: [NewRegisterFormService, Formvalidator, NewRegisterViewService, EmployerFormService, NewProjectViewService, PersonFormService, ConfirmService, AppService, Countries, EmployerViewService, ConfirmModalService, MatDatepicker, DateUpdateFix, NgxSmartModalService, AuthenticationService],
    templateUrl: './new.register.form.component.html',  
    styleUrls: ['../register.component.css']  
})

export class NewRegisterFormComponent {
                
    @ViewChild('validationModal') validationModal: ValidationModalComponent;
    @ViewChild(SearchDropdownComponent) searchDropdown: SearchDropdownComponent;

    // Get translation/text from translation.json
    private i18 = translateJson.i18;

    // Customer settings
    private customerSettings = customerJson.settings;
    private customerOrgId = customerJson.customer.organisationId;
    private edition: String = customerJson.edition;
    rkReceiverActive: Boolean = this.customerSettings.RKReceiver;
    rkShowOperatorAndSupervisor: Boolean = this.customerSettings.rkShowOperatorAndSupervisor;
    private globalOrgAssociations: boolean = customerJson.settings.globalOrgAssociations;
    showProjectOperatorInSuaList: Boolean = customerJson.settings.showProjectOperatorInSuaList;
    autoClearOrgNrOperator: Boolean = customerJson.settings.autoClearOrgNrOperator;

    private activeComponent: boolean;
    employerSelected: boolean = false;
    registerControl: any;
    receiver: any;
    editRkBool: boolean = false;
    showTextInput: boolean = true;
    extraDatesAvailable: boolean = false;
    person: any;
    reasons: any = [];
    ready: boolean;
    company: any;
    projects: any = [];
    companyUniqueProjects: any = [];
    companies: any = [];
    suaCompanyAvailable: boolean;
    suaAvailable: boolean;
    personDetailsForm: FormGroup;
    personSsnSearch: FormGroup;
    suaDetailsForm: FormGroup;
    suaCompanyForm: FormGroup;
    extraDatesAvailableForm: FormGroup;
    private rkAttachmentForm: FormGroup;
    editReceiverPersonForm: FormGroup;
    separateListItemForm: FormGroup;
    personAvailable: String;
    filteredNames: Observable<any[]>;    
    rkReceiverPerson: FormGroup;
    @ViewChild('suaForm') public suaForm:ElementRef;
    @ViewChild('extraDatesForm') public extraDatesForm:ElementRef;
    type: any;
    receiverPersonArray: any;    
    selectedReceiverPersonOption: number;
    public id: any;
    purposeOfControlArray: any [];
    suaStatusType = SuaStatusType;
    selectableOrgAssociations: Array<any> = [];    
    generateDiary: boolean;
    numOfNotes:number = 0;
    currentCitizenship: String = "";
    otherCitizenship: String = "";

    employedByCustomer: boolean = false;

    addressCodeFilterList: any = [];
    addressCodeExists: boolean;
    professionsFilterList: any = [];
    professionExists:boolean;
    rkOperatorFilterList: any = [];
    rkRegulatorFilterList: any = [];
    private showRKSecondAttachmentTab: boolean = customerJson.settings.showRKSecondAttachmentTab;    
    private otherType: String = otherTypeEnum[0];
    private securityClass: String = '3';
    selectedFellowApplicant: any = {};
    private enableDigitalXmlExport:boolean = customerJson.settings.enableDigitalXmlExport;
    selectedProfessionId: string = '';
    selectedAddressCodeId: string = '';
    selectedReceiverPersonId: string = '';

    constructor(
        private service: NewRegisterFormService,          
        private confirmService: ConfirmService,
        private personService: PersonFormService,
        private countries: Countries,
        private formValidator: Formvalidator,
        private companyService: EmployerFormService,
        private activatedRoute: ActivatedRoute,
        private formBuilder: FormBuilder,
        private employerViewService: EmployerViewService,
        private registerService: NewRegisterViewService,
        private projectService: NewProjectViewService,
        private globals: Globals,
        private dateAdapter: DateAdapter<Date>,
        private appService: AppService,
        private ConfirmModalService: ConfirmModalService,
        private dateUpdateFix: DateUpdateFix,
        private ngxSmartModalService: NgxSmartModalService,
        private authService: AuthenticationService) {
            this.authService.isAuthenticated();
            this.activeComponent = appService.isComponentActive('registercontrol');
            this.type = this.activatedRoute.snapshot.paramMap.get('type');
            this.id = this.activatedRoute.snapshot.paramMap.get('id');
            if(this.id != null && this.type === 'edit') {
                this.projectService.getAllProjects().subscribe(
                    data => this.setProjects(data)
                        .then(() => {
                            this.personAvailable = 'true';
                            this.editRk();
                        }),
                    error =>  this.showErrorDialog(this.validationModal.getModalArray())
                );
            } 
            else if (this.type === 'new') {
                this.projectService.getAllProjects().subscribe(
                    data => this.setProjects(data).
                        then(() => {
                            this.personAvailable = 'false';
                            this.setDefault();
                            if (this.id != null) {
                                if (this.id.length == 13) {
                                    this.getPersonBySsn(this.id)
                                } else {
                                    this.getPersonById(this.id)
                                }
                            }
                        }),
                    error =>  this.showErrorDialog(this.validationModal.getModalArray())
                );
            }
            this.getAllUniqueProfessions();
            this.getAllAddressCodes();
            this.getActiveEmployers();
            this.getActiveAuthorityEmployers();
        }

    /**
     * Initiates values
     */
    setDefault() {
        this.dateAdapter.setLocale('sv');
        this.suaCompanyForm = new FormGroup({
            selectedCompany: new FormControl(),
            dummy: new FormControl()
        });

        this.suaDetailsForm = new FormGroup({
            selectedCompany: new FormControl({disabled: false}),
            companySupplier: new FormControl({disabled: false}),
            companySuaProject: new FormControl({disabled: false})
        });

        this.suaDetailsForm.patchValue({
            companySupplier: ""
        });
         
        this.personDetailsForm = new FormGroup({

            rkStatus: new FormControl(),
            rkRegNumber: new FormControl(),
            rkInternalRegNumber: new FormControl(),
            generateSequenceNumber: new FormControl(false),

            // Receiver fields
            receiverName: new FormControl(),
            receiverPhone: new FormControl(),
            receiverMail: new FormControl(),


            //Autofilled by config if type is new
            orgNrOperator: new FormControl({value: '', disabled: false}),            
            operatorName: new FormControl({value: '', disabled: false}),

            orgNrRegulator: new FormControl({value: '', disabled: false}),
            addressCodeRegulator: new FormControl({value: '', disabled: false}),
            regulatorName: new FormControl({value: '', disabled: false}),

            //Autofilled by person
            personLastName: new FormControl({disabled: false}),
            personFirstName: new FormControl({disabled: false}),
            currentAddress: new FormControl({disabled: false}),
            postalCode: new FormControl({disabled: false}),
            postalCity: new FormControl({disabled: false}),
            ssn: new FormControl({disabled: false}),

            //To be filled by user
            profession: new FormControl(),
            adressCodeOperator: new FormControl(),
            lastDate: new FormControl(),
            reasonText: new FormControl(),
            purposeOfControl: new FormControl(),

            personPhoneNumber: new FormControl(),
            passportNumber: new FormControl(),
            cityOfBirthAbroad: new FormControl(),
             
            countryOfBirthAbroad: new FormControl(),
            currentCitizenship: new FormControl({disabled: false}),
            placeholderNationalityCode: new FormControl(),
            oldCitizenship: new FormControl(),

            otherPostalAddress: new FormControl(),
            otherPostalCode: new FormControl(),
            otherPostalCity: new FormControl(),
            otherAddress: new FormControl(),

            latestAddressAbroad: new FormControl(),
            addressField1: new FormControl(),
            addressField2: new FormControl(),
            addressField3: new FormControl(),
            nameClarification: new FormControl(),


            //Radio's
            securityClass: new FormControl(),
            controlReason: new FormControl(),
            securityInterview: new FormControl(),
            suaAssignment: new FormControl(),           

            //Receiver
            newReceiverPerson: new FormControl(),
            selectedReceiverPerson: new FormControl(),
            'receiverPerson': new FormArray([]),

            selectedOrgAssociation: new FormControl()
        });

        

        this.editReceiverPersonForm = new FormGroup({
            id: new FormControl(),
            oldReceiverName: new FormControl(),
            newReceiverName: new FormControl()
        });

        this.separateListItemForm = new FormGroup({
            id: new FormControl(),
            oldValue: new FormControl(),
            newValue: new FormControl()
        });
        
        this.personDetailsForm.patchValue({
            controlReason: this.i18.rk.form.undefined,
            securityInterview: this.customerSettings.securityClearanceInterviewPerformedSelected.toString(),
            suaAssignment: customerJson.settings.rkIsSUAPreselected?'true':'false',
            rkStatus: this.suaStatusType.NOT_SENT,
            generateDiary: 'false'
        })

        this.extraDatesAvailableForm = new FormGroup({
            extraDatesAvailableReceived: new FormControl(),
            extraDatesAvailableSentSapo: new FormControl(),
            extraDatesAvailablePassed: new FormControl(),
            extraDatesAvailablePersonTold: new FormControl(),
            extraDatesAvailableEndDate: new FormControl()
        });

        this.rkReceiverPerson = new FormGroup({
        })

        this.personSsnSearch = new FormGroup({
            ssnInput: new FormControl('', Validators.required)
        });

        this.rkAttachmentForm = new FormGroup({
            securityClassification: new FormControl(),
            ssn: new FormControl(),
            lastName: new FormControl(),
            firstName: new FormControl(),
            estimatedAssets: new FormControl(),
            enforcementAuthorityDebt: new FormControl(),
            totalDebt: new FormControl(),
            employers: new FormControl(),
            serviceAbroad: new FormControl(),
            otherInformation: new FormControl(),
            fellowSsn: new FormControl({value: null, disabled: false}),
            fellowLastName: new FormControl(),
            fellowFirstName: new FormControl(),
            fellowPhoneNumber: new FormControl(),
            fellowEmployer: new FormControl(),
            fellowPassportNumber: new FormControl(),
            fellowBirthPlaceAbroad: new FormControl(),
            fellowCountryOfBirthAbroad: new FormControl(),
            fellowCurrentCitizenship: new FormControl(),
            fellowOtherCitizenship: new FormControl(),
            fellowEstimatedAssets: new FormControl(),
            fellowEnforcementAuthorityDebt: new FormControl(),
            fellowTotalDebt: new FormControl(),
            fellowOtherAddressFieldOne: new FormControl(),
            fellowOtherAddressFieldTwo: new FormControl(),
            fellowOtherAddressFieldThree: new FormControl(),
            fellowOtherAddressFieldCountry: new FormControl(),
            nameClarification: new FormControl(),
            fellowApplicantIsSelected: new FormControl()
        })    

        this.registerService.getAllReceivers().subscribe(
            data => this.patchReceiverPersons(data),
            error => this.showError(error.error)
        );

        if(this.type === 'new'){
            if(this.globals.autofillSendData) {
                this.autofillSend();
            }
            if(customerJson.settings.rkIsSUAPreselected === true){
                this.enableSua();
            } else {
                this.disableSua()
            }
        }


        this.purposeOfControlArray = customerJson.sapoFormValues.purposeOfControlArray;
        this.extraDatesAvailable = customerJson.settings.extraDatesAvailable;
        this.ready = true;
    }   

    /**
    * Patch the receiver drop-down with already known receivers
    */
    patchReceiverPersons(data: any): void {        
        if (!this.rkReceiverActive) return;
        
        this.receiverPersonArray = data;
        
        const selectedReceiverPerson = this.personDetailsForm.value.selectedReceiverPerson;
        if (selectedReceiverPerson != null && selectedReceiverPerson !== '' && !this.receiverPersonExists(selectedReceiverPerson)) {
            let modalData = this.validationModal.getModalArray();
            modalData[0] = this.i18.rk.form.receiverMissing;
            modalData[1] = `${this.i18.rk.form.theReceiver} "${this.personDetailsForm.value.selectedReceiverPerson}" ${this.i18.rk.form.patchReceiver}`
            this.validationModal.pop();

            this.personDetailsForm.controls.selectedReceiverPerson.reset()
        }
    }

    /**
    * Allows for deletion of a receiver person
    * This will remove the person permanently from the list
    */
    deleteReceiverPerson(inputReceiverPerson): void {
        const personToDelete = this.receiverPersonArray.find(receiverPerson => receiverPerson.receiverName === inputReceiverPerson);

        if (personToDelete) {
            this.confirmService.confirm(`${this.i18.rk.form.theReceiver} "${personToDelete.receiverName}" ${this.i18.rk.form.deleteReceiver}`)
                .then(userWantsToDelete => {
                    if (userWantsToDelete) {
                        this.registerService.deleteRecieverPerson(personToDelete.id).subscribe(() => {
                            this.receiverPersonArray = this.receiverPersonArray.filter(receiverPerson => receiverPerson.id != personToDelete.id);
                            this.personDetailsForm.controls.selectedReceiverPerson.reset();
                        },
                            error => this.showError(error)
                        );
                    }
                })
        }
        else {
        this.confirmService.error(this.i18.rk.form.errorDeleteReceiver);
        }
    }

    /**
     * Checks if the input receiver person exists in the array of all receiver persons.
     * @param receiverPerson Name/contact details of a receiver person.
     */
    receiverPersonExists(inputReceiverPerson: String): boolean {
        return this.receiverPersonArray.find(receiverPerson => receiverPerson.receiverName === inputReceiverPerson ? true : false);
    }

    /*
    * Helper to validate data before populating the array with it
    */
    validateInput(inputName, formArray) {
        let validInput = true;
        for(let i=0; i < formArray.length; i++) {
            if (inputName.toUpperCase() == formArray.value[i].receiverName.toUpperCase()) {
                validInput = false;
            }
        }
        return validInput;
    }

    /* Initiates forms before editing */
    editRk() {
        this.registerService.getRkById(this.id)
            .subscribe(
                data => this.setData(data),
                error =>  this.showError(error.error)
            );
    }

    /*
    * Helper method to autofill information we get from the configuration and lock the fields
    */
    autofillSend() {
       this.personDetailsForm.patchValue({
            orgNrOperator: customerJson.customerGenericValues.customerOrgId,
            adressCodeOperator: customerJson.customerGenericValues.customerSapoCode,
            operatorName: customerJson.customerGenericValues.customerName,

            orgNrRegulator: customerJson.customerGenericValues.regulatorOrgId,
            addressCodeRegulator: customerJson.customerGenericValues.regulatorSapoCode,
            regulatorName: customerJson.customerGenericValues.regulatorName
        })        

        /*this.personDetailsForm.get("orgNrOperator").disable();
        this.personDetailsForm.get("adressCodeOperator").disable();
        this.personDetailsForm.get("operatorName").disable();
        this.personDetailsForm.get("orgNrRegulator").disable();
        this.personDetailsForm.get("addressCodeRegulator").disable();
        this.personDetailsForm.get("regulatorName").disable();*/
    }

    /* Patch form with known data */
    setData(data) {
        this.registerControl = data;
        this.person = data.person;

        this.employedByCustomer = this.personIsEmployedByCustomer(data.person)

		this.setSelectableOrgAssociations();

        this.setDefault();
        let checkedPersonName: String;
        if(data.person.middleName === null) {
          checkedPersonName = data.person.firstName;
        } else {
          checkedPersonName = data.person.firstName + ' ' + data.person.middleName;
        }
        this.otherCitizenship = this.registerControl.oldCitizenship;
        let personSsn: String;
        if(data.placeholderSsn == null || data.placeholderSsn == '') {
            if(data.person.ssn != null && data.person.ssn !== ''){
                personSsn = data.person.ssn;
            } else if ((data.person.ssn == null || data.person.ssn == '') && data.person.coordinationNumber != null && data.person.coordinationNumber != ''){
                personSsn = data.person.coordinationNumber;
            } else if((data.person.ssn == null || data.person.ssn == '') && (data.person.coordinationNumber == null || data.person.coordinationNumber == '') && data.person.birthDate != null && data.person.birthDate != '') {
                personSsn = data.person.birthDate.replaceAll('-', "");
            } else {
                personSsn = null;
            }
        } else {
            personSsn = data.placeholderSsn;
        }
        this.personDetailsForm.patchValue({
            orgNrOperator: this.registerControl.orgNrOperator,
            adressCodeOperator: data.adressCodeOperator,
            operatorName: this.registerControl.operatorName,

            orgNrRegulator: this.registerControl.orgNrRegulator,
            addressCodeRegulator: this.registerControl.addressCodeRegulator,
            regulatorName: this.registerControl.regulatorName,

            personLastName: data.person.lastName,
            personFirstName: checkedPersonName,
            
            ssn: personSsn,
            profession: data.profession,

            personPhoneNumber: data.personPhoneNumber,
            passportNumber: data.person.passportNumber,
            cityOfBirthAbroad: data.cityOfBirthAbroad,
            countryOfBirthAbroad: data.countryOfBirthAbroad,
            placeholderNationalityCode: this.registerControl.placeholderNationalityCode,
            currentCitizenship: this.countries.get2CountryCodeName(this.registerControl.placeholderNationalityCode),
            oldCitizenship: this.countries.get2CountryCodeNames(this.registerControl.oldCitizenship),
            lastDate: (data.lastDate === null ? "" : formatDate(data.lastDate, 'yyyy-MM-dd', 'en')),
            reasonText: data.reasonText,
            purposeOfControl: data.purposeOfControl,

            otherPostalAddress: data.otherPostalAddress,
            otherPostalCode: data.otherPostalCode,
            otherPostalCity: data.otherPostalCity,
            otherAddress: data.otherAddress,

            latestAddressAbroad: data.latestAddressAbroad,
            addressField1: data.addressField1,
            addressField2: data.addressField2,
            addressField3: data.addressField3,
            securityClass: data.rkClassification,
            controlReason: data.controlReason,
            securityInterview: data.securityInterview.toString(),
            suaAssignment: data.suaProject.toString(),
            rkStatus: data.status,
            rkRegNumber: data.rkRegNumber,
            selectedOrgAssociation: this.selectableOrgAssociations[this.findIndexOfOrgAssociationIn(this.registerControl.orgAssociation, this.selectableOrgAssociations)] || null,
            selectedReceiverPerson: data.receiverPerson,
            nameClarification: data.nameClarification,
            rkInternalRegNumber: data.rkInternalRegNumber
        });
        this.setSecurityClass(data.rkClassification)
        this.getCompanies(data.person.employers);
        //patch the supplier orgnumber from the employer stored with the rk if the employer have been removed from the person.
        if((data.person.employers.length === 0 && data.employer != null && data.project != null) || (
            data.employer != null && data.project != null && !this.employerHasProject(data.person.employers, data.project.employer))){
            this.companies.push(data.employer)
        }

        if(this.extraDatesAvailable) {
            this.extraDatesAvailableForm.patchValue({
                extraDatesAvailableReceived: (data.extraDatesAvailableReceived === null ? null : formatDate(data.extraDatesAvailableReceived, 'yyyy-MM-dd', 'en')),
                extraDatesAvailableSentSapo: (data.extraDatesAvailableSentSapo === null ? null : formatDate(data.extraDatesAvailableSentSapo, 'yyyy-MM-dd', 'en')),
                extraDatesAvailablePassed: (data.extraDatesAvailablePassed === null ? null : formatDate(data.extraDatesAvailablePassed, 'yyyy-MM-dd', 'en')),
                extraDatesAvailablePersonTold: (data.extraDatesAvailablePersonTold === null ? null : formatDate(data.extraDatesAvailablePersonTold, 'yyyy-MM-dd', 'en')),
                extraDatesAvailableEndDate: (data.extraDatesAvailableEndDate === null ? null : formatDate(data.extraDatesAvailableEndDate, 'yyyy-MM-dd', 'en'))
            });
        }
        if (this.registerControl.suaProject) {
            this.suaCompanyForm.patchValue({
                selectedCompany: this.registerControl.employer.id,
            });
            this.suaDetailsForm.get("companySupplier").disable();
            this.suaAvailable = true;

            this.setCompanyProjects(this.registerControl.employer.id);
            this.suaDetailsForm.patchValue({
                companySupplier: this.registerControl.employer.name,
                companySuaProject: this.registerControl.project.id
            });
        }
        
        if (data.defaultRkPersonInvestigationAttachment !=null){
            this.rkAttachmentForm.patchValue({
                securityClassification: data.defaultRkPersonInvestigationAttachment.securityClassification,
                ssn: data.defaultRkPersonInvestigationAttachment.ssn,
                lastName: data.defaultRkPersonInvestigationAttachment.lastName,
                firstName: data.defaultRkPersonInvestigationAttachment.firstName,
                estimatedAssets: data.defaultRkPersonInvestigationAttachment.estimatedAssets,
                enforcementAuthorityDebt: data.defaultRkPersonInvestigationAttachment.enforcementAuthorityDebt,
                totalDebt: data.defaultRkPersonInvestigationAttachment.totalDebt,
                employers: data.defaultRkPersonInvestigationAttachment.employers,
                serviceAbroad: data.defaultRkPersonInvestigationAttachment.serviceAbroad,
                otherInformation: data.defaultRkPersonInvestigationAttachment.otherInformation,
                fellowSsn: data.defaultRkPersonInvestigationAttachment.fellowSsn,
                fellowLastName: data.defaultRkPersonInvestigationAttachment.fellowLastName,
                fellowFirstName: data.defaultRkPersonInvestigationAttachment.fellowFirstName,
                fellowPhoneNumber: data.defaultRkPersonInvestigationAttachment.fellowPhoneNumber,
                fellowEmployer: data.defaultRkPersonInvestigationAttachment.fellowEmployer,
                fellowPassportNumber: data.defaultRkPersonInvestigationAttachment.fellowPassportNumber,
                fellowBirthPlaceAbroad: data.defaultRkPersonInvestigationAttachment.fellowBirthPlaceAbroad,
                fellowCountryOfBirthAbroad: data.defaultRkPersonInvestigationAttachment.fellowCountryOfBirthAbroad,
                fellowCurrentCitizenship: data.defaultRkPersonInvestigationAttachment.fellowCurrentCitizenship,
                fellowOtherCitizenship: data.defaultRkPersonInvestigationAttachment.fellowOtherCitizenship,
                fellowEstimatedAssets: data.defaultRkPersonInvestigationAttachment.fellowEstimatedAssets,
                fellowEnforcementAuthorityDebt: data.defaultRkPersonInvestigationAttachment.fellowEnforcementAuthorityDebt,
                fellowTotalDebt: data.defaultRkPersonInvestigationAttachment.fellowTotalDebt,
                fellowOtherAddressFieldOne: data.defaultRkPersonInvestigationAttachment.fellowOtherAddressFieldOne,
                fellowOtherAddressFieldTwo: data.defaultRkPersonInvestigationAttachment.fellowOtherAddressFieldTwo,
                fellowOtherAddressFieldThree: data.defaultRkPersonInvestigationAttachment.fellowOtherAddressFieldThree,
                fellowOtherAddressFieldCountry: data.defaultRkPersonInvestigationAttachment.fellowOtherAddressFieldCountry,
                nameClarification: data.defaultRkPersonInvestigationAttachment.nameClarification
            })
        }
        
        this.fillAttachmentFormPersonDetails();
        this.patchAttachmentFormSecClass(data.rkClassification);

        // Only allow changes to org association if the status is NOT_SENT
        this.setOrgAssociationsEnabled(this.personDetailsForm.value.rkStatus === SuaStatusType.NOT_SENT)

        // Listen to RK status change
        this.personDetailsForm.controls.rkStatus.valueChanges.subscribe(value => {
            this.setOrgAssociationsEnabled(value === SuaStatusType.NOT_SENT);
        })

        /* check for säpo form changes */
        this.checkSapoForm(customerJson.sapoFormValues.purposeOfControlArray, this.registerControl.purposeOfControl, 'warning', data.status);

        this.disablePersonInput();

        // set the number of notes on first load. this will then be updated when a user adds/removes notes
        this.numOfNotes = this.registerControl.notes.length;
    }

    /**
    * Helper to fix dates. If we get nothing from backend it will autocomplete to begining of EPOCH time
    */
    fixDates() {

    }

    /**
     * Retrieves a person based on the person id
     * @param personId Person identifier
     */
    getPersonBySsn(personSsn) {
        this.personService.getPersonBySsn(personSsn).subscribe(
            data => this.displayPerson(data),
            error => this.getPersonError(personSsn)
          );
    }

    /**
     * Retrieves a person based on the person id
     * @param personId Person identifier
     */
    getPersonById(personId) {
        this.personService.getPersonById(personId).subscribe(
            data => this.displayPerson(data),
            error => this.getPersonError(personId)
          );
    }

    /**
     * Prevents the user from modifying person data
     */
    disablePersonInput() {
        this.personDetailsForm.get('personFirstName').disable();
        this.personDetailsForm.get('personLastName').disable();
        this.personDetailsForm.get('ssn').disable();
        this.personDetailsForm.get('currentCitizenship').disable();
        this.personDetailsForm.get('oldCitizenship').disable();
        this.personDetailsForm.get('personPhoneNumber').disable();
        this.personDetailsForm.get('passportNumber').disable();
    }

    setCompanyProjects(companyId) {
        this.companyUniqueProjects = [];
        for(let forProjects of this.projects){
            if(forProjects.employerId === companyId){
                if(!forProjects.archived) {
                    this.companyUniqueProjects.push(forProjects);
                }
            }
        }
        //sort project array on operatorName and then project name
        if(this.edition === 'company' && this.showProjectOperatorInSuaList){
            this.companyUniqueProjects.sort((a, b) => {
                if((a.operatorName != null && b.operatorName != null) && a.operatorName.toLowerCase() < b.operatorName.toLowerCase()) return -1;
                if((a.operatorName != null && b.operatorName != null) && a.operatorName.toLowerCase() > b.operatorName.toLowerCase()) return 1;
                if((a.compIndustry != null && b.compIndustry != null) && a.compIndustry.toLowerCase() < b.compIndustry.toLowerCase()) return -1;
                if((a.compIndustry != null && b.compIndustry != null) && a.compIndustry.toLowerCase() > b.compIndustry.toLowerCase()) return 1;
                return 0
            });
        } else if(this.edition === 'company' && !this.showProjectOperatorInSuaList){
            this.companyUniqueProjects.sort((a, b) => {
                if((a.compIndustry != null && b.compIndustry != null) && a.compIndustry.toLowerCase() < b.compIndustry.toLowerCase()) return -1;
                if((a.compIndustry != null && b.compIndustry != null) && a.compIndustry.toLowerCase() > b.compIndustry.toLowerCase()) return 1;
                return 0
            });
        }

        this.suaDetailsForm.patchValue({
            companySuaProject: null
        });

    }

    /**
     * Show control reason 
     * @param employerId Identifier for employer to retrieve reasons from
     */
    showControlReason(companyId) {
        this.suaDetailsForm.get("companySuaProject").enable();
        this.reasons.length = 0;

        this.setCompanyProjects(companyId);

        //Kod för hantering av kontrollorsak
        /*this.personDetailsForm.get('reasonText').disable();
        

        }*/
        if(this.reasons.length >= 1) {
            this.showTextInput = false;
        } else {
            this.showTextInput = true;
        }

        for(let i=0; i < this.person.employers.length; i++) {
            if(this.person.employers[i].id === companyId) {
                this.suaDetailsForm.patchValue({
                    companySupplier: this.person.employers[i].name
                });
            }
        }

        this.personDetailsForm.get('reasonText').enable();
        this.employerSelected = true;
    }

    /**
     * Shows the RK for specified person
     * @param person 
     */
    displayPerson(person) {
        this.person = person;
        let checkedPersonName: String;

        this.employedByCustomer = this.personIsEmployedByCustomer(person);
        
        this.setSelectableOrgAssociations();


        if(person.middleName === null){
          checkedPersonName = person.firstName;
        } else {
          checkedPersonName = person.firstName + ' ' + person.middleName;
        }
        this.personAvailable = "true";
        this.getCompanies(this.person.employers);


        let countryCodes = this.person.nationalityCode.split(',');
        this.currentCitizenship = countryCodes[0];
        for(let i=1; i<countryCodes.length; i++) {
            this.otherCitizenship += countryCodes[i].trim() + ",";
        }
        this.otherCitizenship =  this.otherCitizenship.slice(0, -1);

        let personSsn: String;
        if(person.ssn != null && person.ssn !== ''){
            personSsn = person.ssn;
        } else if ((person.ssn == null || person.ssn == '') && person.coordinationNumber != null && person.coordinationNumber != ''){
            personSsn = person.coordinationNumber;
        } else if((person.ssn == null || person.ssn == '') && (person.coordinationNumber == null || person.coordinationNumber == '') && person.birthDate != null && person.birthDate != '') {
            personSsn = person.birthDate.replaceAll('-', "");
        } else {
            personSsn = null;
        }

        this.personDetailsForm.patchValue({
            personLastName: person.lastName,
            personFirstName: checkedPersonName,
            ssn: personSsn,
            personPhoneNumber: person.personPhoneNumber,
            passportNumber: person.passportNumber,
            placeholderNationalityCode: this.currentCitizenship,
            currentCitizenship: this.countries.get2CountryCodeName(this.currentCitizenship),
            oldCitizenship: this.countries.get2CountryCodeNames(this.otherCitizenship)
        })
        this.disablePersonInput();
        this.fillAttachmentFormPersonDetails();
      
    }

    /**
     * Retrieves companies
     * @param personEmployer All employers for the specified person 
     */
    getCompanies(personEmployer) {
        this.companies.length = 0;
        for(let i=0; i < personEmployer.length; i++){
            this.companyService.getEmployerById(personEmployer[i].id)      
            .subscribe(
              data => this.setCompanies(data),
              error =>  this.showError(error.error)      
            );
        }
    }

    /**
     * Disables sua
     */
    disableSua() {
        this.suaAvailable = false;
        this.suaDetailsForm.patchValue({
            selectedCompany: "null",
            companySupplier: null,
            companySuaProject: null
        });
    }

    enableSua() {
        this.suaAvailable = true;
        this.suaDetailsForm.get("companySupplier").disable();
        this.suaDetailsForm.get("companySuaProject").disable();
    }

    /**
     * Shows a selected company
     * @param company Company to be shown
     */
    showSelectedCompany(company) {
        let companySelected: any;
        for(let i=0; i < this.person.employers.length; i++) {
            if(this.person.employers[i].id === company) {
                companySelected = this.person.employers[i];
            }
        }
        this.showAndDisableCompanyInput(companySelected);
    }

    /**
     * Shows and disables all company input fields in the form
     * @param companySelected Company which to alter
     */
    showAndDisableCompanyInput(companySelected) {
        this.suaDetailsForm.patchValue({
            companyName: companySelected.name,
            companyOrgId: companySelected.organisationId,
            companyAddress: companySelected.addresses[0].address_1,
            companyPostCode: companySelected.addresses[0].postCode,
            companyCity: companySelected.addresses[0].city,
            companyPhone: companySelected.contactPhone
        });

        this.suaDetailsForm.get('companyName').disable();
        this.suaDetailsForm.get('companyOrgId').disable();
        this.suaDetailsForm.get('companyAddress').disable();
        this.suaDetailsForm.get('companyPostCode').disable();
        this.suaDetailsForm.get('companyCity').disable();
        this.suaDetailsForm.get('companySupplier').disable();
        this.suaDetailsForm.get('companyPhone').disable();

        this.company = companySelected;
        this.suaCompanyAvailable = true;
    }

    /**
     * Set projects to selector list and returns a resolved promise to call the
     * function asynchronously.
     * @param data Projects
     * @returns {Promise} A resolved promise.
     */
    setProjects(data): Promise<void> {
        for(let i=0; i < data.length; i++) {
            //if(data[i].suaCompanyStatus === 'SUA-godkänd') {
                this.projects.push(data[i]);
            //}
        }
        return Promise.resolve()
        //this.projects = data;
    }

    /**
     * Function to move to content on page
     */
    moveToStructure():void {
        this.suaForm.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
        this.extraDatesForm.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
    }

    /**
     * Sets all retrieved companies to list
     * @param data Retrieved companies from backend
     */
    setCompanies(data) {
        this.companies.push(data);
    }

    showErrorDialog(modalData) {
        modalData[0] = this.i18.rk.form.showErrorDialog1;
        modalData[1] = this.i18.rk.form.showErrorDialog2;
        this.validationModal.pop();
    }

    /**
     * Show error
     * @param error error text
     */
    showError(error) { 
        this.confirmService.error(this.appService.getTranslatedErrorMessage(error));        
    }

    defaultBack() {
        this.appService.setRoute("/registercontrol/new");
    }
    
    getPersonError(ssn){
      this.confirmService.error(this.i18.rk.form.getPersonError + " " + ssn)
        .then(result => {
          if(result){
            this.defaultBack();
          }
        });
    }

    /**
     * Called if attempting to leave the RK form while editing
     */
    back() {
        this.confirmService.confirm(this.i18.rk.form.confirmBack)
            .then(result => {
                if (result) {
                    this.setDefault();
                    this.suaAvailable = false;
                    this.suaCompanyAvailable = false;
                    this.personAvailable = "false";
                    this.appService.setRoute('registercontrol/view/' + this.registerControl.id)
                }
            });
    }

    /**
     * Save a new RK
     * @param registerForm   
     * @param suaForm
     * @param extraDatesForm
     */
    saveRegisterControl(registerForm, suaForm, suaCompanyForm, extraDatesAvailableForm) {
        let rk = registerForm;

        rk.status = this.personDetailsForm.get('rkStatus').value;
        rk.rkRegNumber = this.personDetailsForm.get('rkRegNumber').value;
        rk.personId = this.person.id;
        rk.suaProject = this.personDetailsForm.get('suaAssignment').value;
        rk.rkClassification = this.personDetailsForm.get('securityClass').value;
        rk.personPhoneNumber = this.personDetailsForm.get('personPhoneNumber').value

        rk.extraDatesAvailable = customerJson.settings.extraDatesAvailable;
        rk.lastDate = this.dateUpdateFix.fixDateOnUpdate(registerForm.lastDate)
        rk.extraDatesAvailableReceived = this.dateUpdateFix.fixDateOnUpdate(this.extraDatesAvailableForm.get('extraDatesAvailableReceived').value);
        rk.extraDatesAvailableSentSapo = this.dateUpdateFix.fixDateOnUpdate(this.extraDatesAvailableForm.get('extraDatesAvailableSentSapo').value);
        rk.extraDatesAvailablePassed = this.dateUpdateFix.fixDateOnUpdate(this.extraDatesAvailableForm.get('extraDatesAvailablePassed').value);
        rk.extraDatesAvailablePersonTold = this.dateUpdateFix.fixDateOnUpdate(this.extraDatesAvailableForm.get('extraDatesAvailablePersonTold').value);
        rk.extraDatesAvailableEndDate = this.dateUpdateFix.fixDateOnUpdate(this.extraDatesAvailableForm.get('extraDatesAvailableEndDate').value);
        rk.oldCitizenship = this.otherCitizenship != '' ? this.otherCitizenship : null;
        // Set configured fields
        rk.orgNrOperator = this.personDetailsForm.get('orgNrOperator').value;
        rk.adressCodeOperator = this.personDetailsForm.get('adressCodeOperator').value;
        rk.operatorName = this.personDetailsForm.get('operatorName').value;
        //set the value to null if blank
        rk.orgNrRegulator = this.personDetailsForm.get('orgNrRegulator').value === '' ? null : this.personDetailsForm.get('orgNrRegulator').value;
        rk.addressCodeRegulator = this.personDetailsForm.get('addressCodeRegulator').value === '' ? null : this.personDetailsForm.get('addressCodeRegulator').value;
        rk.regulatorName = this.personDetailsForm.get('regulatorName').value === '' ? null : this.personDetailsForm.get('regulatorName').value;

        rk.receiverPerson = this.personDetailsForm.value.selectedReceiverPerson

        rk.orgAssociation = this.setRkOrgAssociation();
        if(rk.suaProject == 'true') {
            rk.employerId = suaCompanyForm.selectedCompany;
            rk.suaId = suaForm.companySuaProject != "null" ? suaForm.companySuaProject : null;
        }

        rk = this.checkRkCountries(rk);
        if(!this.checkObjectAllNull(this.rkAttachmentForm.value)){
            Object.keys(this.rkAttachmentForm.value).forEach(key => this.rkAttachmentForm.value[key] = this.rkAttachmentForm.value[key] === '' ? null : this.rkAttachmentForm.value[key]);
            rk.defaultRkPersonInvestigationAttachment = this.rkAttachmentForm.value
            if(this.rkAttachmentForm.get('fellowApplicantIsSelected').value != null && Object.keys(this.rkAttachmentForm.get('fellowApplicantIsSelected').value).length > 0){
                rk.defaultRkPersonInvestigationAttachment = this.patchAttachmentBeforeSave(rk.defaultRkPersonInvestigationAttachment);
            }
            rk.defaultRkPersonInvestigationAttachment = this.checkRkAttachmentCounties(rk.defaultRkPersonInvestigationAttachment);
        } else {
            rk.defaultRkPersonInvestigationAttachment = null;
        }

        if(!this.receiverPersonInList(rk.receiverPerson)){
            this.confirmService.confirm(`${this.i18.rk.form.rkSubmitterMainLabel.toLowerCase()} ${this.i18.rk.form.confirmReciverPerson1} "${rk.receiverPerson}" ${this.i18.rk.form.confirmReciverPerson2}`)
            //this.confirmService.confirm(`${this.i18.receiverPerson.form.receiverPersonMainLabel.toLowerCase()} ${this.i18.receiverPerson.form.receiverPersonNewConfirmText1.toLowerCase()} "${rk.receiverPerson}" ${this.i18.receiverPerson.form.receiverPersonNewConfirmText2.toLowerCase()}`)
            .then(wantToSave => {
                if(wantToSave){
                this.service.saveRk(rk, this.enableDigitalXmlExport)
                .subscribe(
                    data => this.setRoute('registercontrol/view/' + data.id),
                    error => this.showError(error)
                );
                }
            })
        } else {
            this.service.saveRk(rk, this.enableDigitalXmlExport)
                .subscribe(
                    data => this.setRoute('registercontrol/view/' + data.id),
                    error => this.showError(error)
                );
        }
    }

    /**
     * Updates the RK
     * @param registerForm 
     * @param suaForm 
     */
    updateRegisterControl(registerForm, suaForm, suaCompanyForm, extraDatesAvailableForm) {

        let rk = registerForm;

        rk.id = this.registerControl.id;
        rk.status = this.personDetailsForm.get('rkStatus').value;
        rk.rkRegNumber = this.personDetailsForm.get('rkRegNumber').value;
        rk.personId = this.person.id;
        rk.suaProject = this.personDetailsForm.get('suaAssignment').value;
        rk.rkClassification = this.personDetailsForm.get('securityClass').value;
        rk.lastDate = ((registerForm.lastDate === null || registerForm.lastDate === "") ? null : this.dateUpdateFix.fixDateOnUpdate(registerForm.lastDate));
        rk.placeholderDisplayName = this.registerControl.placeholderDisplayName;
        rk.placeholderSsn = this.registerControl.placeholderSsn;
        rk.personPhoneNumber = this.personDetailsForm.get('personPhoneNumber').value

        rk.extraDatesAvailable = customerJson.settings.extraDatesAvailable;

        rk.extraDatesAvailableReceived = ((extraDatesAvailableForm.extraDatesAvailableReceived === null || extraDatesAvailableForm.extraDatesAvailableReceived === "") ? null : this.dateUpdateFix.fixDateOnUpdate(extraDatesAvailableForm.extraDatesAvailableReceived));
        rk.extraDatesAvailableSentSapo = ((extraDatesAvailableForm.extraDatesAvailableSentSapo === null || extraDatesAvailableForm.extraDatesAvailableSentSapo === "") ? null : this.dateUpdateFix.fixDateOnUpdate(extraDatesAvailableForm.extraDatesAvailableSentSapo));
        rk.extraDatesAvailablePassed = ((extraDatesAvailableForm.extraDatesAvailablePassed === null || extraDatesAvailableForm.extraDatesAvailablePassed === "") ? null : this.dateUpdateFix.fixDateOnUpdate(extraDatesAvailableForm.extraDatesAvailablePassed));
        rk.extraDatesAvailablePersonTold = ((extraDatesAvailableForm.extraDatesAvailablePersonTold === null || extraDatesAvailableForm.extraDatesAvailablePersonTold === "") ? null : this.dateUpdateFix.fixDateOnUpdate(extraDatesAvailableForm.extraDatesAvailablePersonTold));
        rk.extraDatesAvailableEndDate = ((extraDatesAvailableForm.extraDatesAvailableEndDate === null || extraDatesAvailableForm.extraDatesAvailableEndDate === "") ? null : this.dateUpdateFix.fixDateOnUpdate(extraDatesAvailableForm.extraDatesAvailableEndDate));

        rk.receiverPerson = this.personDetailsForm.value.selectedReceiverPerson

		rk.orgAssociation = this.setRkOrgAssociation();

        rk.oldCitizenship = this.otherCitizenship != '' ? this.otherCitizenship : null;

        // Set configured fields
        rk.orgNrOperator = this.personDetailsForm.get('orgNrOperator').value;
        rk.adressCodeOperator = this.personDetailsForm.get('adressCodeOperator').value;
        rk.operatorName = this.personDetailsForm.get('operatorName').value;
        //set the value to null if blank
        rk.orgNrRegulator = this.personDetailsForm.get('orgNrRegulator').value === '' ? null : this.personDetailsForm.get('orgNrRegulator').value;
        rk.addressCodeRegulator = this.personDetailsForm.get('addressCodeRegulator').value === '' ? null : this.personDetailsForm.get('addressCodeRegulator').value;
        rk.regulatorName = this.personDetailsForm.get('regulatorName').value === '' ? null : this.personDetailsForm.get('regulatorName').value;
        //rk.orgNrRegulator = this.personDetailsForm.get('orgNrRegulator').value;
        //rk.addressCodeRegulator = this.personDetailsForm.get('addressCodeRegulator').value;
        //rk.regulatorName = this.personDetailsForm.get('regulatorName').value;
      
        if(rk.suaProject == 'true') {
            rk.employerId = suaCompanyForm.selectedCompany;
            rk.suaId = suaForm.companySuaProject != "null" ? suaForm.companySuaProject : null;           
        }

        rk = this.checkRkCountries(rk);

        if(!this.checkObjectAllNull(this.rkAttachmentForm.value)){
            Object.keys(this.rkAttachmentForm.value).forEach(key => this.rkAttachmentForm.value[key] = this.rkAttachmentForm.value[key] === '' ? null : this.rkAttachmentForm.value[key]);
            rk.defaultRkPersonInvestigationAttachment = this.rkAttachmentForm.value
            if(this.rkAttachmentForm.get('fellowApplicantIsSelected').value != null && Object.keys(this.rkAttachmentForm.get('fellowApplicantIsSelected').value).length > 0){
                rk.defaultRkPersonInvestigationAttachment = this.patchAttachmentBeforeSave(rk.defaultRkPersonInvestigationAttachment);
            }
            rk.defaultRkPersonInvestigationAttachment = this.checkRkAttachmentCounties(rk.defaultRkPersonInvestigationAttachment);
        } else {
            rk.defaultRkPersonInvestigationAttachment = null;
        }



        if(!this.receiverPersonInList(rk.receiverPerson)){
            this.confirmService.confirm(`${this.i18.rk.form.rkSubmitterMainLabel.toLowerCase()} ${this.i18.rk.form.confirmReciverPerson1} "${rk.receiverPerson}" ${this.i18.rk.form.confirmReciverPerson2}`)
            //this.confirmService.confirm(`${this.i18.receiverPerson.form.receiverPersonMainLabel.toLowerCase()} ${this.i18.receiverPerson.form.receiverPersonNewConfirmText1.toLowerCase()} "${rk.receiverPerson}" ${this.i18.receiverPerson.form.receiverPersonNewConfirmText2.toLowerCase()}`)
            .then(wantToSave => {
                    if(wantToSave) {
                    this.service.updateRk(rk, this.enableDigitalXmlExport)
                    .subscribe(
                        data => this.setRoute('registercontrol/view/' + data.id),
                        error => this.showError(error)
                    );
                }
            })
        } else {
            this.service.updateRk(rk, this.enableDigitalXmlExport)
                .subscribe(
                    data => this.setRoute('registercontrol/view/' + data.id),
                    error => this.showError(error)
                );
        }       
    }

    setRoute(route) {
        this.appService.setRoute(route);
    }
        
    setRouteRk(id) {
        this.appService.setRoute('/registercontrol/new/'+id);
    }
    
    backToStart() {
        this.appService.setRoute('/registercontrol');
    }

    /**
   * Function for automatically formatting the ssn if the user does not format correctly
   * @param ssn the ssn to format and patch into the form
   */
  ssnFix(ssn) {
    if((ssn.length === 10 || ssn.length === 12) &&ssn[ssn.length-5] != "-") {
      ssn = ssn.substring(0, ssn.length-4) + "-" + ssn.slice(ssn.length-4);
    }
    if(ssn.replace("-", "").trim().length === 10) {
      if(ssn.replace("-", "").trim()[0] < 3) {
        ssn = "20" + ssn;
      } else {
        ssn = "19" + ssn;
      }
    }
    if(ssn.slice(ssn.length-2) === "tf") {
      ssn = ssn.substring(0, ssn.length-2) + "TF";
    }
    this.personSsnSearch.patchValue({
      ssnInput: ssn
    });
  }


	/**
	 * Checks if the input association exists in the given array and returns
	 * a true if it exists.
	 * @param inputAssociation An organisational association.
	 * @param orgAssociations An array of organisational associations.
	 */
	orgAssociationExistsIn(inputAssociation: any, orgAssociations: Array<any>): boolean {
		return this.findIndexOfOrgAssociationIn(inputAssociation, orgAssociations) != null;
	}

	/**
	 * Retrieves the index of which the input association is located in the given array.
	 * Returns null if not found.
	 * @param inputAssociation An organisational association.
	 * @param orgAssociations An array of organisational associations.
	 */
	findIndexOfOrgAssociationIn(inputAssociation: any, orgAssociations: Array<any>): any {
		if (inputAssociation == null) return null;

		const index = orgAssociations.findIndex(orgAssociation =>
			orgAssociation.department === inputAssociation.department
			&& orgAssociation.entity === inputAssociation.entity
			&& orgAssociation.section === inputAssociation.section);

		return index < 0 ? null : index;
	}

	/**
	 * Set the rkOrgAssociation to the selected orgAssociation.
	 * @param rkOrgAssociation An organisational association.
	 */
	setRkOrgAssociation(): any {
		const selected = this.personDetailsForm.getRawValue().selectedOrgAssociation;

		if (selected != null) {
			// Do not include the ID of selected, else the RK orgAssociation will reference the orgAssociation
			// of the Person, which it should not.
			return { department: selected.department, entity: selected.entity, section: selected.section };
		}
		return null;
	}

	/**
	 * Sets the selectable org associations to match the list of associations on the Person object. If
	 * the RK has a stored association that has been deleted on the Person object, it is also added
	 * to the list.
	 */
	setSelectableOrgAssociations(): void {
        if (!this.globalOrgAssociations && !this.employedByCustomer) return;

		if (!this.registerControl || this.registerControl.orgAssociation == null || this.orgAssociationExistsIn(this.registerControl.orgAssociation, this.person.orgAssociations)) {
            this.selectableOrgAssociations = this.person.orgAssociations;
		}
		else {
			this.selectableOrgAssociations = [...this.person.orgAssociations];
            this.selectableOrgAssociations.push(this.registerControl.orgAssociation);
		}
    }
    
    /**
     * Check if the customer organisation ID exist on one of the person's employers.
     * @param person Person entity.
     */
    personIsEmployedByCustomer(person: any): boolean {
        return person.employers.find(employer => employer.organisationId === this.customerOrgId) ? true : false;
    }

    /**
     * Set the enabled status of the input field for org associations.
     * @param value True/false
     */
    setOrgAssociationsEnabled(status: boolean): void {
        if (status == true) {
            this.personDetailsForm.controls.selectedOrgAssociation.enable();
        }
        else {
            this.personDetailsForm.controls.selectedOrgAssociation.disable();
        }
    }

    /**
     * Toggle the generate diary functinality
    */
   customDiaryDisabler() {
    if (this.personDetailsForm.value.generateSequenceNumber) {
        this.personDetailsForm.get('rkInternalRegNumber').disable();
        this.personDetailsForm.patchValue({rkInternalRegNumber: this.i18.rk.form.rkGenerateInternalDiaryNumberPlaceholder});

    } else {
        this.personDetailsForm.get('rkInternalRegNumber').enable();
        this.personDetailsForm.patchValue({rkInternalRegNumber: null});
    }

}

    /**
    * check if a receiver person already exists in the receiver person list
    */
    receiverPersonInList(selectedReceiverPerson: String): boolean {
        if(selectedReceiverPerson != null && selectedReceiverPerson !== ''){
            return this.receiverPersonArray.find(receiverPerson => receiverPerson.receiverName.toLowerCase() === selectedReceiverPerson.toLowerCase() ? true : false);
        } else if (selectedReceiverPerson == null || selectedReceiverPerson === '') {
            return true;
        }
    }

    /**
     * Checks if a value is in a list of values used from the customer.json file.
     * ex checks if a stored value for puropse of control is still amongst the values used in the dropdown
     * if not displays a modal notifing the user that the form has been updated and gives the option to keep the old value or to pick a new one.
     * @param sapoValueList the list of valid dropdown values
     * @param oldValue the value currently stored in the database
     * @param msgType the type of message the modal shoud present
     */
    checkSapoForm(sapoValueList, oldValue, msgType, status){
        if(sapoValueList.length > 0){
            let persistedExists = sapoValueList.includes(oldValue);

            if(!persistedExists && status === SuaStatusType.NOT_SENT){
                let title = this.i18.rk.form.checkSapoForm1
                let msg = [this.i18.rk.form.checkSapoForm2, this.i18.rk.form.checkSapoForm3 + " " + oldValue + " " + this.i18.rk.form.checkSapoForm4];

                this.ConfirmModalService.pop(msg, title, true, this.i18.rk.form.checkSapoForm5, true, this.i18.rk.form.checkSapoForm6, msgType)
                .then(keepPersistedValue => {
                    if (keepPersistedValue) {
                        let tmpArr = [];
                        tmpArr.push(oldValue);
                        tmpArr.push(...this.purposeOfControlArray); 
                        this.purposeOfControlArray = tmpArr;
                    } else {
                        this.personDetailsForm.patchValue({purposeOfControl: null })
                    }
                })
            } else {
                let tmpArr = [];
                tmpArr.push(oldValue);
                tmpArr.push(...this.purposeOfControlArray); 
                this.purposeOfControlArray = tmpArr;
            }
        }

    }

    getAllAddressCodes() {
        this.service.getAllAddressCodes()
        .subscribe(
            data => this.setAddressCodeFilterList(data),
            error => this.showError(error.error)
        );
    }

    /**
     * Set the addressCodes drop-down with existing codes
     * @param data 
     */
    setAddressCodeFilterList(data: any): void {
        this.addressCodeFilterList = data;
    }   

    /**
     * 
     * @param value If written addressCode already exists
     */
    setAddressCodeExists(value){
        this.addressCodeExists = value;
    }

    /**
    * Allows for deletion of an address code
    * This will remove the adress code permanently from the list
    */
     deleteAddressCodeFromList(addressCode): void {
        const addressCodeToDelete = this.addressCodeFilterList.find(code => code.addressCode === addressCode);

        if (addressCodeToDelete) {
            this.confirmService.confirm(`"${addressCodeToDelete.addressCode}" ${this.i18.rk.filterList.rkRemoveFromList}`)
                .then(userWantsToDelete => {
                    if (userWantsToDelete) {
                        this.service.deleteAddressCode(addressCodeToDelete.id)
                        .subscribe(
                            data => {
                                this.personDetailsForm.controls.adressCodeOperator.reset();
                                this.setAddressCodeExists(false);
                                this.getAllAddressCodes();
                            },
                            error => this.showError(error.error)
                        );
                    }
                })
        }
        else {
            this.confirmService.error(this.i18.rk.filterList.rkRemoveErrorFromList);
        }
    }


    /**
     * Method that gets a list of unique previously stored professions
     */
     getAllUniqueProfessions(){
        this.service.getAllUniqueProfessions()
        .subscribe(
            data => this.setProfessionsFilterList(data),
            error => this.showError(error.error)
        );
    }

    /**
     * Set all unique professions to global variable
     * @param data
     */
    setProfessionsFilterList(data) {
        this.professionsFilterList = data
    }

    /**
    * Allows for deletion of a receiver person
    * This will remove the person permanently from the list
    */
     deleteProfessionFromList(professionName): void {
        const professionToDelete = this.professionsFilterList.find(profession => profession.professionName === professionName);

        if (professionToDelete) {
            this.confirmService.confirm(`"${professionToDelete.professionName}" ${this.i18.rk.filterList.rkRemoveProfessionFromList}`)
                .then(userWantsToDelete => {
                    if (userWantsToDelete) {
                        this.service.deleteProfession(professionToDelete.id)
                        .subscribe(
                            data => {
                                this.personDetailsForm.controls.profession.reset();
                                this.setProfessionExists(false);
                                this.getAllUniqueProfessions();
                            },
                            error => this.showError(error.error)
                        );
                    }
                })
        }
        else {
            this.confirmService.error(this.i18.rk.filterList.rkRemoveErrorFromList);
        }
    }

    setProfessionExists(value){
        this.professionExists = value;
    }

    /**
     * Helper to set rk operator organisation id if operator selected from list
     * @param value boolean
     */
    setOperatorValues(value: any) {   
        if(value){
            let operator = this.rkOperatorFilterList.find(operator => operator.id === value);
            this.personDetailsForm.patchValue({
                orgNrOperator: operator.organisationId
            });
            this.formValidator.validateOrgNrOperator(operator.organisationId);            
        } else if (!value && this.registerControl != null && this.personDetailsForm.get('operatorName').value === this.registerControl.operatorName.trim()) {
            this.personDetailsForm.patchValue({
                orgNrOperator: this.registerControl.orgNrOperator
            })
            this.formValidator.validateOrgNrOperator(this.registerControl.orgNrOperator);
        } else if (!value){
            if ((this.personDetailsForm.get('operatorName').value != null && this.personDetailsForm.get('operatorName').value != "" && customerJson.customerGenericValues.customerName != "") && this.personDetailsForm.get('operatorName').value === customerJson.customerGenericValues.customerName) {
                this.personDetailsForm.patchValue({
                    orgNrOperator: this.customerOrgId
                });
                this.formValidator.validateOrgNrOperator(this.customerOrgId);
            } else if (!this.autoClearOrgNrOperator && this.personDetailsForm.get('operatorName').value != null && this.personDetailsForm.get('operatorName').value != ""){
                this.formValidator.validateOrgNrOperator(this.customerOrgId);
            } else {                
                this.personDetailsForm.patchValue({
                    orgNrOperator: null
                });
                //this.formValidator.validateOrgNrOperator("NaN"); // Display red input error
            }            
        }        
    }

    /**
     * Helper to set rk regulator organisation id if regulator selected from list
     * @param value boolean
     */
    setRegulatorValues(value){
        if(value){
            let regulator = this.rkOperatorFilterList.find(regulator => regulator.id === value);
            this.personDetailsForm.patchValue({
                orgNrRegulator: regulator.organisationId
            });
        } else if (!value && this.registerControl != null && this.personDetailsForm.get('regulatorName').value === this.registerControl.regulatorName) {
            this.personDetailsForm.patchValue({
                orgNrRegulator: this.registerControl.orgNrRegulator
            })
        } else if (!value){
            this.personDetailsForm.patchValue({
                orgNrRegulator: null
            });
        }
    }

    /**
     * Get all employers from the backend
     * and populate the filter dropdown list
     */
     getActiveEmployers() {
        this.companyService.getActiveEmployers()
            .subscribe(
                data => this.setRkOperatorFilterList(data),
                error => this.showError(error.error)       
      )
    }

    /**
     * Get all authority employers from the backend
     * and populate the filter dropdown list
     */
     getActiveAuthorityEmployers() {
        this.companyService.getActiveAuthorityEmployers()
            .subscribe(
                data => this.setRkRegulatorFilterList(data),
                error => this.showError(error.error)       
      )
    }


    /**
     * Helper to populate the operator filter list
     * @param data list of employers
     */
    setRkOperatorFilterList(data){
        this.rkOperatorFilterList = data;
    }

    /**
     * Helper to populate the regulator filter list
     * @param data list of authority type employers
     */
    setRkRegulatorFilterList(data){
        this.rkRegulatorFilterList = data;
    }

    /*fixDateOnUpdate(dateToFix){
        let fixedDate = new Date(dateToFix);
        fixedDate.setHours(13);
        return fixedDate
    }*/
    /**
     *  Set other type
     *  @param type type of page
     */
     setOtherType(type:number) {
        this.otherType = otherTypeEnum[type];
    }

    /**
     * Sets the rkclassification for the attachement
     * also used to to/hide the tabs
     * @param rkClass 
     */
    setSecurityClass(rkClass:string){
        this.securityClass = rkClass;
        this.patchAttachmentFormSecClass(rkClass);
    }

    /**
     * Returns true if user have nott filled in the person investigation form
     * returns false if user have filled in any value in the form
     * @param obj person investigation form object
     * @returns boolean
     */
    checkObjectAllNull(obj:object){
        let objCounter:number = 0
        let excludedFields = ['securityClassification', 'ssn', 'lastName', 'firstName', 'fellowApplicantIsSelected']
        for (let o in obj){
            if((obj[o] == null || obj[o] === '' ) && !excludedFields.includes(o)){
                objCounter++;
            }
        }
        //return true if all is null
        if(objCounter === (Object.keys(obj).length - excludedFields.length) && (obj['fellowApplicantIsSelected'] == null || obj['fellowApplicantIsSelected'] === 'null' || Object.keys(obj['fellowApplicantIsSelected']).length === 0)){
            return true
        } else if(obj['fellowApplicantIsSelected'] != null && obj['fellowApplicantIsSelected'] != 'null' && Object.keys(obj['fellowApplicantIsSelected']).length !== 0){
            return false
        } else {
            return false
        }
    }

    /**
     * Eighter clears or deletes a form depending on action
     * @param action action to take
     */
    clearAttachmentForm(action: string){
        if(this.type === 'edit' && action === this.i18.rk.attachment.rkAttRemove) {
            let title = this.i18.rk.attachment.rkAttDeleteModalTitle;
            let msg = [this.i18.rk.attachment.rkAttDeleteModalMessage];
            this.ConfirmModalService.pop(msg, title, true, this.i18.rk.attachment.rkAttModalConfirmButton, true, this.i18.rk.attachment.rkAttModalAbortButton, "warning")
                .then(removeAttachment => {
                    if (removeAttachment) {
                        this.service.deleteRkAttachment(this.registerControl.id)
                            .subscribe(
                                data => {
                                    this.rkAttachmentForm.reset();
                                    this.registerControl.defaultRkPersonInvestigationAttachment = null;
                                    this.fillAttachmentFormPersonDetails();
                                    this.patchAttachmentFormSecClass(this.registerControl.rkClassification);
                                },
                                error => this.showErrorDialog(this.validationModal.getModalArray())
                            );
                    }
                })
        } else {
            this.rkAttachmentForm.reset();
            this.fillAttachmentFormPersonDetails();
            this.patchAttachmentFormSecClass(this.registerControl.rkClassification);
        }
    }

    /**
     * fill or clear the fellowApplicant part of attachment form depending
     * on dropbox selection
     */
    fillFellowApplicant(){
        if(this.selectedFellowApplicant != null && this.selectedFellowApplicant != 'null'){

            let fellowIdentity: String;
            if(this.selectedFellowApplicant.ssn != null && this.selectedFellowApplicant.ssn !== ''){
                fellowIdentity = this.selectedFellowApplicant.ssn;
            } else if ((this.selectedFellowApplicant.ssn == null || this.selectedFellowApplicant.ssn == '') && this.selectedFellowApplicant.coordinationNumber != null && this.selectedFellowApplicant.coordinationNumber != ''){
                fellowIdentity = this.selectedFellowApplicant.coordinationNumber;
            } else if((this.selectedFellowApplicant.ssn == null || this.selectedFellowApplicant.ssn == '') && (this.selectedFellowApplicant.coordinationNumber == null || this.selectedFellowApplicant.coordinationNumber == '')) {
                fellowIdentity = this.selectedFellowApplicant.birthDate.replaceAll('-', "");
            }
            this.rkAttachmentForm.patchValue({
                fellowSsn: fellowIdentity,
                fellowLastName: this.selectedFellowApplicant.lastName,
                fellowFirstName: this.selectedFellowApplicant.firstName
            })
            this.rkAttachmentForm.get('fellowSsn').disable();
            this.rkAttachmentForm.get('fellowLastName').disable();
            this.rkAttachmentForm.get('fellowFirstName').disable();
                    
        } else {
            this.rkAttachmentForm.patchValue({
                fellowSsn: null,
                fellowLastName: null,
                fellowFirstName: null
            })
            this.rkAttachmentForm.get('fellowSsn').enable();
            this.rkAttachmentForm.get('fellowLastName').enable();
            this.rkAttachmentForm.get('fellowFirstName').enable();
        }
    }

    /**
     * Patch the person investigation attachment form with person information in new and edit mode
     */
    fillAttachmentFormPersonDetails(){
        if(this.person != null){
            let personIdentity: String;
            if(this.person.ssn != null && this.person.ssn !== ''){
                personIdentity = this.person.ssn;
            } else if ((this.person.ssn == null || this.person.ssn == '') && this.person.coordinationNumber != null && this.person.coordinationNumber != ''){
                personIdentity = this.person.coordinationNumber;
            } else if((this.person.ssn == null || this.person.ssn == '') && (this.person.coordinationNumber == null || this.person.coordinationNumber == '') && this.person.birthDate != null && this.person.birthDate != '') {
                personIdentity = this.person.birthDate.replaceAll('-', "");
            } else {
                personIdentity = null;
            }
            this.rkAttachmentForm.patchValue({
                ssn: personIdentity,
                lastName: this.person.lastName,
                firstName: this.person.middleName!=null ? this.person.firstName + ' ' + this.person.middleName : this.person.firstName
            })
        }
    }

    /**
     * Patch the person investigation attachment form with same security class as set on the rk form
     * @param rkClass rk security class
     */
    patchAttachmentFormSecClass(rkClass:string){
        this.rkAttachmentForm.patchValue({
            securityClassification: rkClass
        })
    }

    /**
     * Patch the person investigation attachment form with fellow applicant details before saveing
     * @param obj attachment object
     * @returns person investigation attachment form
     */
    patchAttachmentBeforeSave(obj: object){
        let fellowApplicantObject = this.rkAttachmentForm.get('fellowApplicantIsSelected').value
        let personIdentity: String;
        if(fellowApplicantObject.ssn != null && fellowApplicantObject.ssn !== ''){
            personIdentity = fellowApplicantObject.ssn;
        } else if ((fellowApplicantObject.ssn == null || fellowApplicantObject.ssn == '') && fellowApplicantObject.coordinationNumber != null && fellowApplicantObject.coordinationNumber != ''){
            personIdentity = fellowApplicantObject.coordinationNumber;
        } else if((fellowApplicantObject.ssn == null || fellowApplicantObject.ssn == '') && (fellowApplicantObject.coordinationNumber == null || fellowApplicantObject.coordinationNumber == '')) {
            personIdentity = fellowApplicantObject.birthDate.replaceAll('-', "");
        }
        obj['fellowSsn'] = personIdentity
        obj['fellowLastName'] = fellowApplicantObject.lastName
        obj['fellowFirstName'] = fellowApplicantObject.firstName
        return obj;
    }

    /**
     * Anchor
     * @param target id
     */
     public anchor(target): void {
        this.appService.scrollToTarget(target);
    }

    /**
     * Helper to update the number of notes displayed on top of the page.
     * Checks if the value from the notes component is a number and updates it.
     * If the value is not a number the amount of notes is taken from the notes array received in the initial request.
     * @param numOfNotes
     */
    setNumOfNotes(numOfNotes: number){
        if(numOfNotes != null && !Number.isNaN(numOfNotes)){
            this.numOfNotes = numOfNotes;
        } else {
            this.numOfNotes = this.registerControl.notes.length;
        }
    }

    /**
     * Helper to check if employer set to the sua is still a employer for the person
     * @param employerList list of persons employers
     * @param projectEmployer employer set to sua
     * @returns boolean
     */
    employerHasProject(employerList, projectEmployer){
        let foundProjectEmployer = false;
        employerList.forEach(employer => {
            if(employer.id === projectEmployer.id){
                foundProjectEmployer = true;
            }
        });
        return foundProjectEmployer;
    }

    /**
     * Helper to check if defaultregistercontrol countrycodes are 'null'
     * @param rk defaultregistercontrol objekt
     * @returns defaultregistercontrol
     */
    checkRkCountries(rk) {
        if(rk.countryOfBirthAbroad === 'null'){
            rk.countryOfBirthAbroad = null;
        }
        if(rk.oldCitizenship === 'null'){
            rk.oldCitizenship = null;
        }
        if(rk.otherAddress === 'null'){
            rk.otherAddress = null;
        }
        if(rk.addressField3 === 'null'){
            rk.addressField3 = null;
        }
        return rk;
    }

    /**
     * helper to open the edit receiverperson modal.
     */
    openEditReceiverModal(){
        this.ngxSmartModalService.getModal('receiverPersonEditModal').open();
    }

    /**
     * helper to close the edit receiverperson modal.
     */
    closeEditReceiverModal(){
        this.editReceiverPersonForm.reset();
        this.ngxSmartModalService.getModal('receiverPersonEditModal').close();
    }

    /**
    * Allows for deletion of a receiver person
    * This will remove the person permanently from the list
    */
    editReceiverPerson(oldReceiverPerson): void {
        const personToEdit = this.receiverPersonArray.find(receiverPerson => receiverPerson.receiverName === oldReceiverPerson);
        this.editReceiverPersonForm.patchValue({
            id: personToEdit.id,
            oldReceiverName: personToEdit.receiverName
        })
        const newReceiverName = this.editReceiverPersonForm.value.newReceiverName;

        this.service.updateReceiver(this.editReceiverPersonForm.value)
            .subscribe(
                data => {
                    this.personDetailsForm.patchValue({
                        selectedReceiverPerson: newReceiverName
                    });
                    this.patchReceiverPersons(data);
                    this.closeEditReceiverModal();
                },
                error => this.showError(error)
            );
    }

    /**
     * Helper to check if rk attachment countrycodes are 'null'
     * @param rkAttachment
     * @returns rk attachment
     */
     checkRkAttachmentCounties(rkAttachment) {
        if(rkAttachment.fellowCountryOfBirthAbroad === 'null'){
            rkAttachment.fellowCountryOfBirthAbroad = null;
        }
        if(rkAttachment.fellowCurrentCitizenship === 'null'){
            rkAttachment.fellowCurrentCitizenship = null;
        }
        if(rkAttachment.fellowOtherCitizenship === 'null'){
            rkAttachment.fellowOtherCitizenship = null;
        }
        if(rkAttachment.fellowOtherAddressFieldCountry === 'null'){
            rkAttachment.fellowOtherAddressFieldCountry = null;
        }
        return rkAttachment;
    }

    setNameClarification(projectId) {
        if(projectId != null && projectId.trim() !== 'null' && projectId.trim() !== ''){
            let project = this.companyUniqueProjects.find(sua => sua.id === projectId);
            if(project != null && project.nameClarification != null && project.nameClarification.trim() !== '') {
                this.personDetailsForm.patchValue({
                    nameClarification: project.nameClarification
                });
            } else {
                this.personDetailsForm.patchValue({
                    nameClarification: null
                });
            }
        }
    }

    /**
     * Open modal prepare form depending on what type to perform the update on
     * @param type type to be updated
     */
    openEditModal(type: string) {
        if (type === 'profession'){
            const professionToEdit = this.professionsFilterList.find(profession => profession.id === this.selectedProfessionId);
            this.separateListItemForm.patchValue({
                id: professionToEdit.id,
                oldValue: professionToEdit.professionName
            })
        }
        if (type === 'addressCodeOperator' && this.selectedAddressCodeId !== null && this.selectedAddressCodeId !==''){
            const addressCodeOperatorToEdit = this.addressCodeFilterList.find(addressCode => addressCode.id === this.selectedAddressCodeId);
            this.separateListItemForm.patchValue({
                id: addressCodeOperatorToEdit.id,
                oldValue: addressCodeOperatorToEdit.addressCode
            })
        }
        if (type === 'receiverPerson' && this.selectedReceiverPersonId !== null && this.selectedReceiverPersonId !==''){
            const receiverPersonToEdit = this.receiverPersonArray.find(receiverPerson => receiverPerson.id === this.selectedReceiverPersonId);
            this.separateListItemForm.patchValue({
                id: receiverPersonToEdit.id,
                oldValue: receiverPersonToEdit.receiverName
            })
        }
        this.ngxSmartModalService.setModalData(type, 'editModal', true);
        this.ngxSmartModalService.getModal('editModal').open();
    }

    /**
     * helper to close the edit receiverperson modal.
     */
    closeEditModal(type){
        if(type === 'profession') {
            this.selectedProfessionId = ''
        } else if(type === 'addressCodeOperator') {
            this.selectedAddressCodeId = ''
        } else if(type === 'receiverPerson') {
            this.selectedReceiverPersonId = ''
        }
        this.separateListItemForm.reset();
        this.ngxSmartModalService.getModal('editModal').close();
    }

    /**
     * call specific update function depending on which of profession, receiverPerson or adressCodeOperator is to be updated 
     * @param type type to be updated
     */    
    editTypeData(type): void {
        if (type === 'profession'){
            const newProfessionName = this.separateListItemForm.value.newValue;
            this.service.updateProfession(this.separateListItemForm.value)
                .subscribe(
                    data => {
                        this.patchSeparateListItem('profession', data, newProfessionName);
                        this.closeEditModal('profession');
                    },
                    error => this.showError(error)
                );
        } else if (type === 'addressCodeOperator'){
            const newAddressCodeName = this.separateListItemForm.value.newValue;
            this.service.updateAddressCode(this.separateListItemForm.value)
                .subscribe(
                    data => {
                        this.patchSeparateListItem('addressCodeOperator', data, newAddressCodeName);
                        this.closeEditModal('addressCodeOperator');
                    },
                    error => this.showError(error)
                );
        } else if (type === 'receiverPerson'){
            const newReceiverName = this.separateListItemForm.value.newValue;

            this.service.updateReceiver(this.separateListItemForm.value)
                .subscribe(
                    data => {
                        this.personDetailsForm.patchValue({
                            selectedReceiverPerson: newReceiverName
                        });
                        this.patchReceiverPersons(data);
                        this.closeEditModal('receiverPerson');
                    },
                    error => this.showError(error)
                );
        }
    }

    /**
     * set the id to be updated
     * @param id id of profession
     */
    setSelectedProfessionId(id: string) {
        this.selectedProfessionId = id;
    }
    
    /**
     * set the id to be updated
     * @param id id of adressCodeOperator
     */
    setSelectedAddressCodeId(id: string) {
        this.selectedAddressCodeId = id;
    }
    
    /**
     * set the id to be updated
     * @param id id of receiverPerson
     */
    setSelectedReceiverPersonId(id: string) {
        this.selectedReceiverPersonId = id;
    }

    /**
     * Patch the form after the update has been done.
     * @param type type to patch after update
     * @param data data from backend
     * @param currentValue old value
     */
    patchSeparateListItem(type: string, data: any, currentValue: string){
        let valueToPatch;
        if(type === 'profession') {
            this.professionsFilterList = data;
            valueToPatch = this.professionsFilterList.find(profession => profession.professionName === currentValue)
            this.personDetailsForm.patchValue({
                profession: valueToPatch.professionName
            })
        } else if(type === 'addressCodeOperator') {
            this.addressCodeFilterList = data;
            valueToPatch = this.addressCodeFilterList.find(addressCode => addressCode.addressCode === currentValue)
            this.personDetailsForm.patchValue({
                adressCodeOperator: valueToPatch.addressCode
            })
        } else if(type === 'receiverPerson') {
            valueToPatch = this.receiverPersonArray.find(receiverPerson => receiverPerson.receiverName === currentValue)
            this.personDetailsForm.patchValue({
                receiverPerson: valueToPatch.professionName
            })
            this.patchReceiverPersons(data);
        }
    }

    /**
     * Helper to autocomplete a date with missing dividers '-'
     * @param date date string to patch
     * @param form the form to use
     * @param formControlName the formControlName to be patched with the date.
     */
    patchDate(date: string, form: string, formControlName: string) {
        if(date != null) {
            date = date.replace(/-/g,'');
        }
        if((date != null && date.trim() !== '') && 
        (formControlName != null && formControlName.trim() !== '') && date.length >= 8) {
            let yearPossition = 4;
            let monthPossition = 6;
            let dateDivader = '-'
            let patchedDate = date.substring(0,yearPossition) + dateDivader + date.substring(yearPossition, monthPossition) + dateDivader + date.substring(date.length-2, date.length)
            if(form === 'personDetailsForm') {
                this.personDetailsForm.patchValue({
                    [formControlName]: patchedDate
                })
            }
            if (form === 'extraDatesAvailableForm') {
                this.extraDatesAvailableForm.patchValue({
                    [formControlName]: patchedDate
                })
            }
        }
    }
}  